/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParcelV } from './parcelV.model';


/**
 * GeoJSON Feature
 */
export interface GeoJsonFeatureParcelV { 
    /**
     * GeoJSON geometrie (RFC 7946 Geometry object), null pokud objekt geometrii nemá
     */
    geometry?: object | null;
    /**
     * Vlastnosti objektu
     */
    properties?: ParcelV;
    /**
     * Typ GeoJSON objektu
     */
    type?: string;
}

